import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../redux/LotteryAction";
import { useEffect, useState } from "react";
import {
  LotteryBetTypeConst,
  LotteryTypeConst,
  LotteryTypeTitleConst,
} from "../../../../constants/LotteryNavConst";
import { useIntl } from "react-intl";
import toAbsoluteUrl from "to-absolute-url";
import {
  LotteryHLCompanyConst,
  LotteryMKTCompanyConst,
} from "../../../../constants/LotteryCompanyConst";

export const LotteryPayout = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [lotteryType, setLotteryType] = useState(
    LotteryTypeConst.BASIC_LOTTERY
  );

  const lotteryState = useSelector(({ lottery }) => lottery, shallowEqual);

  useEffect(() => {
    dispatch(actions.getLotteryPrizeUI());
  }, []);

  const getLotteryPrize = (lotteryBetType) => {
    const betPrizeList =
      lotteryType === LotteryTypeConst.BASIC_LOTTERY
        ? lotteryState.lotteryPrizeUI.mKTPrize
        : lotteryState.lotteryPrizeUI.hLPrize;

    return betPrizeList.find(
      (betPrize) => betPrize.bettypedscp === lotteryBetType
    ).betType;
  };

  return (
    <>
      <div className="d-flex mb-4">
        {Object.entries(LotteryTypeConst).map(([key, value], index) => (
          <div
            key={index}
            className={`p-2 px-4 cursor-pointer me-3 rounded col-2 text-center ${
              lotteryType === value ? "bg-prim text-dark fw-bold" : ""
            }`}
            onClick={() => {
              setLotteryType(value);
            }}
            style={{ background: "rgba(0, 0, 0, 0.3)" }}
          >
            {intl.formatMessage({ id: LotteryTypeTitleConst[index].title })}
          </div>
        ))}
      </div>
      {lotteryState.listLoading || !lotteryState.lotteryPrizeUI ? (
        <Skeleton className="w-100" style={{ height: "500px" }} />
      ) : (
        <>
          <div className="d-flex align-items-center mb-3">
            {(lotteryType === LotteryTypeConst.HL_LOTTERY
              ? LotteryHLCompanyConst
              : LotteryMKTCompanyConst
            ).map((lotteryCompany, index) => (
              <div key={index}>
                <img
                  style={{ width: "40px" }}
                  className="me-3"
                  src={toAbsoluteUrl(lotteryCompany.lotteryUrl)}
                  alt={lotteryCompany.lotteryCode}
                />
              </div>
            ))}
          </div>
          <div className="d-flex custom-border border-bottom-0">
            <div className="col-3 p-3 fs-5 fw-bold custom-border-end bg-light text-dark">
              {intl.formatMessage({ id: "prize" }).toUpperCase()}
            </div>
            <div className="col-3 p-3 fs-5 fw-bold custom-border-end bg-light text-dark text-end">
              {intl.formatMessage({ id: "big" }).toUpperCase()}
            </div>
            <div className="col-3 p-3 fs-5 fw-bold custom-border-end bg-light text-dark text-end">
              {intl.formatMessage({ id: "small" }).toUpperCase()}
            </div>
            <div className="col-3 p-3 fs-5 fw-bold bg-light text-dark text-end">
              {intl.formatMessage({ id: "4a" }).toUpperCase()}
            </div>
          </div>
          <div className="d-flex custom-border border-bottom-0">
            <div className="col-3 p-3 fs-5 fw-bold custom-border-end text-muted">
              1st {intl.formatMessage({ id: "prize" })}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.BIG).prize1}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.SMALL).prize1}
            </div>
            <div className="col-3 fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.FOUR_A).prize1}
            </div>
          </div>
          <div className="d-flex custom-border border-bottom-0">
            <div className="col-3 p-3 fs-5 fw-bold custom-border-end text-muted">
              2nd {intl.formatMessage({ id: "prize" })}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.BIG).prize2}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.SMALL).prize2}
            </div>
            <div className="col-3 fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.FOUR_A).prize2}
            </div>
          </div>
          <div className="d-flex custom-border border-bottom-0">
            <div className="col-3 p-3 fs-5 fw-bold custom-border-end text-muted">
              3rd {intl.formatMessage({ id: "prize" })}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.BIG).prize3}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.SMALL).prize3}
            </div>
            <div className="col-3 fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.FOUR_A).prize3}
            </div>
          </div>
          <div className="d-flex custom-border border-bottom-0">
            <div className="col-3 p-3 fs-5 fw-bold custom-border-end text-muted">
              {intl.formatMessage({ id: "special" })}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.BIG).prize4}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.SMALL).prize4}
            </div>
            <div className="col-3 fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.FOUR_A).prize4}
            </div>
          </div>
          <div className="d-flex custom-border">
            <div className="col-3 p-3 fs-5 fw-bold custom-border-end text-muted">
              {intl.formatMessage({ id: "consolation" })}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.BIG).prize5}
            </div>
            <div className="col-3 custom-border-end fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.SMALL).prize5}
            </div>
            <div className="col-3 fs-5 p-3 fw-semibold text-end">
              {getLotteryPrize(LotteryBetTypeConst.FOUR_A).prize5}
            </div>
          </div>
        </>
      )}
    </>
  );
};
